import React from 'react';

export default class Pending extends React.Component {
    render() {
        return (
            <div className="App">
                <h1>Pending</h1>
            </div>
        );
    }
}